import script from "./TenantManagement.vue?vue&type=script&lang=ts&setup=true"
export * from "./TenantManagement.vue?vue&type=script&lang=ts&setup=true"

import "./TenantManagement.vue?vue&type=style&index=0&id=3bf33110&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf33110"]])

export default __exports__